import { render, staticRenderFns } from "./Badges.vue?vue&type=template&id=443393ed&scoped=true"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"
import style0 from "./Badges.vue?vue&type=style&index=0&id=443393ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443393ed",
  null
  
)

export default component.exports